import * as Types from './types';
import { redirect } from 'js/utils/url.util';

export const initExternalAuth = (personalId: string): Promise<Types.IExternalAuthInitResponse> => {
    return new Promise((resolve, reject) => {
        if (!window.externalAuth?.init) {
            reject('playtech.mobile.system.bankIDAuth.externalScript.externalAuthMethodsUnavailable');
        }

        window.externalAuth.init({
            personalId,
            callback: (response: Types.IExternalAuthInitResponse) => {
                resolve(response);
            }
        });
    });
};

export const loginToBankID = (actionToken: string): Promise<Types.ILoginToBankIDResponse> => {
    return new Promise((resolve, reject) => {
        if (!window.externalAuth?.startPolling) {
            reject('playtech.mobile.system.bankIDAuth.externalScript.externalAuthMethodsUnavailable');
        }

        window.externalAuth.startPolling({ actionToken }, (response: Types.ILoginToBankIDResponse) => {
            resolve(response);
        });
    });
};

export const redirectToBankIDUrl = (bankIDUrl: string, autoStartToken: string): void => {
    const url = bankIDUrl
        .replace('[TOKEN]', autoStartToken)
        .replace('[RETURNURL]', encodeURIComponent(''));

    redirect(url);
};
